module.exports = __webpack_public_path__ + "img/women_young.5ef174ee.png";